import React from 'react';
import {
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from 'reactstrap';

import Text, { getText } from '../../components/Text';

export default function PasswordInputFormGroup(props) {
  const {
    errorMessage,
    fieldName,
    topDefaultLabel,
    bottomDefaultLabel,
  } = props;
  const INVALID_INPUT_CLASS = 'is-invalid';
  const INVALID_TEXT_CLASS = 'invalid-feedback';

  return (
    <FormGroup>
      <Row>
        <Col>
          <Label for={fieldName}>
            <Text value={topDefaultLabel} />
          </Label>
          <Input
            type="password"
            name={fieldName}
            id={fieldName}
            className={errorMessage ? INVALID_INPUT_CLASS : ''}
            onChange={(evt) => props.onUserInput(fieldName, evt.target.value)}
          />
          <small className={errorMessage ? INVALID_TEXT_CLASS : ''}>
            {errorMessage || getText(bottomDefaultLabel) }
          </small>
        </Col>
      </Row>
    </FormGroup>
  );
}
